import classNames from 'classnames'

/**
 * Utility for conditional class name composition.
 * Re-exports classnames for consistent usage across the app.
 */
export const cn = classNames
